import colors from '../../assets/colors.json';

const getColors = (i) => {
  return colors[i % 12].color;
};

export default getColors;
